import React from 'react';
import PropTypes from 'prop-types';
import StatusPill from './pill/StatusPill';

const DOMAIN_LABELS = {
  short_url: {
    available: 'Unclaimed',
    consumed: 'In use',
  },
  kit: {
    available: 'Unused',
    consumed: 'Used',
  },
};

// Unclaimed is a resting state rather than an achievement, so it is neutral: the old solid blue
// made every unused code look like something had happened to it.
function resolveStatus(invalidated, consumed) {
  if (invalidated) {
    return {
      label: 'Invalidated',
      tone: 'quiet',
      title: 'This code has been invalidated and can no longer be used.',
    };
  }
  if (consumed) {
    return { state: 'consumed', tone: 'success' };
  }
  return { state: 'available', tone: 'neutral' };
}

export default function RedeemableCodeStatusBadge({
  domain,
  invalidated = false,
  consumed = false,
  className = '',
}) {
  const status = resolveStatus(invalidated, consumed);
  const labels = DOMAIN_LABELS[domain];

  let label = status.label;
  let title = status.title;

  if (!label) {
    label = labels[status.state];
    title =
      status.state === 'consumed'
        ? domain === 'short_url'
          ? 'This access URL has been claimed to an asset.'
          : 'This kit code has been used.'
        : domain === 'short_url'
          ? 'This access URL is available to claim.'
          : 'This kit code has not been used yet.';
  }

  return (
    <StatusPill tone={status.tone} title={title} className={className}>
      {label}
    </StatusPill>
  );
}

export function redeemableCodeStatusLabel(domain, invalidated, consumed) {
  const status = resolveStatus(invalidated, consumed);
  if (status.label) return status.label.toLowerCase();
  return DOMAIN_LABELS[domain][status.state].toLowerCase();
}

RedeemableCodeStatusBadge.propTypes = {
  domain: PropTypes.oneOf(['short_url', 'kit']).isRequired,
  invalidated: PropTypes.bool,
  consumed: PropTypes.bool,
  className: PropTypes.string,
};

RedeemableCodeStatusBadge.defaultProps = {
  invalidated: false,
  consumed: false,
  className: '',
};
